import type { TemporaryContractReasonType } from '@libs/data-access/entities'
import { Controller } from '@libs/ui/form'
import { useMembershipPageTranslation } from '@libs/utils/translations'
import type { FC } from 'react'
import React from 'react'
import { useFormContext } from 'react-hook-form'

import { useTemporaryContractReasons } from './hook/useTemporaryContractReasons'

type Props = {
  disabled?: boolean
}

export const TemporaryContractReason: FC<Props> = ({ disabled }) => {
  const { t } = useMembershipPageTranslation()

  const {
    control,
    formState: { errors }
  } = useFormContext<{
    temporary_contract_reason: TemporaryContractReasonType
  }>()

  const temporaryContractReasons = useTemporaryContractReasons()

  return (
    <Controller.Select
      {...(!disabled && {
        placeholder: t('contractModal.temporaryContractReason.placeholder')
      })}
      control={control}
      options={temporaryContractReasons}
      name='temporary_contract_reason'
      label={t('contractModal.temporaryContractReason.label')}
      data-testid='field-temporary_contract_reason'
      disabled={disabled}
      dropdownWidth='target'
      errorMessage={errors?.temporary_contract_reason?.message}
    />
  )
}
